export default "__VITE_ASSET__c0524b2d__"